<template>
    <div class="Collapser">
        <div class="Collapser-container">
            <div
                :class="{ 'Collapser-content--expanded': visible }"
                class="Collapser-content"
            >
                <component
                    :is="component"
                    v-if="component"
                    v-bind="{ ...props, ...$attrs }"
                    v-on="forwardedEvents"
                />
                <p
                    v-else
                    v-html="$sanitize(text)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
import { forwardEvents } from '@/StoreWeb/js/forward-events'

const emit = defineEmits([])

defineProps({
    component: {
        type: String,
        default: null
    },
    props: {
        type: Object,
        default: () => {}
    },
    text: {
        type: String,
        default: ''
    },
    visible: {
        type: Boolean,
        required: true
    }
})

const forwardedEvents = forwardEvents(emit)
</script>

<style lang="scss" scoped>
@import 'globalScss';

.Collapser {
    margin-left: $s8;

    &-container {
        overflow: hidden;
    }

    &-content {
        margin-top: -100%;
        padding: $s4 0;
        transition: margin-top .6s ease-in-out;

        &--expanded {
            margin-top: 0;
        }
    }
}
</style>
